import React from "react";
import cc from "classcat";

interface PrimaryButtonProps extends React.ComponentProps<"button"> {
  children: React.ReactNode;
  className?: string;
  loading?: boolean;
  disabled?: boolean;
}

export function PrimaryButton(props: PrimaryButtonProps) {
  const { children, disabled, loading, className, ...rest } = props;

  const buttonClass = cc([
    "border-radius-primary inline-flex items-center px-4 py-2 border border-transparent body !font-medium rounded-md shadow-sm cta-text bg-primary focus-primary focus-primary-border",
    {
      "opacity-50": disabled || loading,
      "cursor-not-allowed": disabled,
      "cursor-wait": loading,
    },
    className,
  ]);

  return (
    <button {...rest} className={buttonClass}>
      {children}
    </button>
  );
}
